import { DragHandleIcon, EditIcon } from '@chakra-ui/icons';
import { Box, Checkbox, Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
import React from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import ImageListViewer from '../../../Shared/FileListViewer/FileListViewer';
import { actions } from 'react-table';
import { SuccesToastWithText } from '../../../Shared/ToastMessage/SuccessToast';
import { DeleteTaskBtn } from '../../Job/Task/DeleteTaskBtn/DeleteTaskBtn';

export default function ChecklistItem(props) {

    const { task, setTask, onOpen, tenantID, JobID, index, moveTask, doc, value } = props;

    return (
        <>
            <Box >
                <Flex>

                    <Flex width="100%" borderRadius="0.5em"
                        borderColor="gray.100"
                        borderWidth="3px"
                        p="2"
                        // borderStyle="dashed"
                        boxShadow="lg"
                    >
                        <Icon as={DragHandleIcon} cursor="pointer" mt="1" mr="2" />
                        <Box mt="-0.5" textAlign="left" overflowWrap="break-word">
                            <Text>{task.TaskTitle} </Text>
                            <Text fontSize="0.8em" width="100%" display="table" wordBreak="break-word">{task.TaskDescription}</Text>

                            <ImageListViewer
                                isLive
                                fileArray={task?.TaskFiles?.map((file) => {
                                    return { ...file, isAdded: true, }
                                })} //get existing files
                            />

                        </Box>

                        <Box ml="auto" >
                            <Checkbox top="1" borderRadius="3em" />
                        </Box>
                    </Flex>

                    <Box ml="1" >
                        <Menu  >
                            <MenuButton as={Text} textAlign="center" cursor="pointer" >
                                <EditIcon ml="2" mb="0.35em" />
                            </MenuButton>
                            <MenuList >
                                <MenuItem onClick={
                                    () => {
                                        setTask(task);
                                        onOpen()
                                    }
                                }>
                                    <EditIcon mr="1" /> Edit Task
                                </MenuItem>
                                <Box width="100%">
                                    <DeleteTaskBtn
                                        TenantID={tenantID}
                                        JobID={JobID}
                                        TaskID={task.TaskID}

                                    // display="inline-block" float="right" 
                                    />
                                </Box>
                                {index !== 0 &&
                                    <MenuItem onClick={
                                        () => {
                                            moveTask(doc.data(), value.docs[index - 1].data())
                                        }
                                    }>
                                        <Box width="100%">
                                            <Icon as={FiChevronUp} color="green.500" mb="1" /> Move Up
                                        </Box>
                                    </MenuItem>
                                }
                                {index !== value.docs.length - 1 &&
                                    <MenuItem onClick={
                                        () => {
                                            moveTask(doc.data(), value.docs[index + 1].data())
                                        }
                                    }>
                                        <Box width="100%">
                                            <Icon as={FiChevronDown} color="green.500" mb="1" /> Move Down
                                        </Box>
                                    </MenuItem>
                                }
                            </MenuList>
                        </Menu>

                    </Box>
                </Flex>

            </Box>
        </>
    )
}
